import React from 'react';
import styled from 'styled-components';
import Button from './ui/Button';
import Container from './ui/Container';
import { ArrowRight } from './ui/Icons';
import { Eyebrow } from './ui/SectionHeading';
import { formatDate, readingLabel, type BlogPost } from '../data/blog';

const Root = styled.header`
  padding: clamp(3.5rem, 8vw, 6rem) 0 clamp(2.5rem, 6vw, 4rem);
  background:
    linear-gradient(180deg, rgba(7, 12, 22, 0) 50%, var(--bg-0) 100%),
    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px) 0 0 / 64px 64px,
    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px) 0 0 / 64px 64px,
    var(--bg-0);
`;

const Back = styled.div`
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  font-size: var(--fs-display);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
  max-width: 24ch;
`;

const Meta = styled.p`
  margin-top: 1.25rem;
  font-size: var(--fs-small);
  color: var(--text-3);
`;

const Lead = styled.p`
  margin-top: 1.25rem;
  max-width: 62ch;
  font-size: clamp(1.0625rem, 1.4vw, 1.1875rem);
  color: var(--text-2);
`;

const Cover = styled.figure`
  margin-top: 2rem;

  img {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 10;
    object-fit: cover;
    border-radius: var(--radius-lg);
    border: 1px solid var(--border);
  }
`;

const PostHeader: React.FC<{ post: BlogPost }> = ({ post }) => (
  <Root>
    <Container $narrow>
      <Back>
        <Button to="/blog" variant="ghost">
          <ArrowRight style={{ transform: 'rotate(180deg)' }} />{' '}
          {post.lang === 'es' ? 'Volver al blog' : 'Back to blog'}
        </Button>
      </Back>
      {post.tags[0] && <Eyebrow>{post.tags[0]}</Eyebrow>}
      <Title id="post-title">{post.title}</Title>
      <Meta>
        {post.author} · <time dateTime={post.date}>{formatDate(post.date, post.lang)}</time> ·{' '}
        {readingLabel(post.readingMinutes, post.lang)}
      </Meta>
      <Lead>{post.description}</Lead>
      {post.cover && (
        <Cover>
          <img
            src={post.cover.src}
            srcSet={post.cover.srcSet}
            sizes="(min-width: 944px) 880px, calc(100vw - 2.5rem)"
            alt={post.coverAlt ?? ''}
            width={post.cover.width}
            height={post.cover.height}
            fetchPriority="high"
          />
        </Cover>
      )}
    </Container>
  </Root>
);

export default PostHeader;
